export default "__VITE_ASSET__GQJEKhIZ__"